import * as React from "react";
import type { SVGProps } from "react";
const SvgSingleUser = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20" {...props}
  >
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M16.666 16.667v-.625a3.54 3.54 0 0 0-3.541-3.542h-6.25a3.54 3.54 0 0 0-3.542 3.542v.625"
    />
    <circle
      cx={10}
      cy={5.833}
      r={3.333}
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
    />
  </svg>
);
export default SvgSingleUser;
